<template>
  <button class="mt-2" data-cy="operation-item">
    <icon-base
      :icon="config[operation].icon"
      :view-box="config[operation].viewBox"
      :icon-color="config[operation].iconColor"
      width="20"
      height="20"
    />
  </button>
</template>

<script lang="ts" setup>
import { MathOperation } from "@/enums/customAttributes";

import IconDivide from "@/components/icons/IconDivide.vue";
import IconMultiply from "@/components/icons/IconMultiply.vue";
import IconParenthesis from "@/components/icons/IconParenthesis.vue";
import IconParenthesisEnd from "@/components/icons/IconParenthesisEnd.vue";
import IconParenthesisStart from "@/components/icons/IconParenthesisStart.vue";
import IconPercent from "@/components/icons/IconPercent.vue";
import IconPower from "@/components/icons/IconPower.vue";
import IconSubtract from "@/components/icons/IconSubtract.vue";
import IconAdd from "@/components/icons/deals/IconAdd.vue";

import type { PropType, defineAsyncComponent } from "vue";

defineProps({
  operation: {
    type: String as PropType<string | MathOperation>,
    required: true,
  },
});

type ConfigOptions = {
  icon: ReturnType<typeof defineAsyncComponent>;
  viewBox: string;
  iconColor?: string;
};

const config: Record<string | MathOperation, ConfigOptions> = {
  [MathOperation.add]: {
    icon: IconAdd,
    viewBox: "0 -1 20 20",
  },
  [MathOperation.subtract]: {
    icon: IconSubtract,
    viewBox: "0 -1 20 20",
  },
  [MathOperation.multiply]: {
    icon: IconMultiply,
    viewBox: "0 -1 12 12",
  },
  [MathOperation.divide]: {
    icon: IconDivide,
    viewBox: "0 -1 12 12",
  },
  [MathOperation.power]: {
    icon: IconPower,
    viewBox: "0 0 12 12",
    iconColor: "none",
  },
  [MathOperation.percentage]: {
    icon: IconPercent,
    viewBox: "0 -1 12 12",
  },
  parenthesis: {
    icon: IconParenthesis,
    viewBox: "0 -1 12 12",
  },
  parenthesisStart: {
    icon: IconParenthesisStart,
    viewBox: "0 -1 5 13",
  },
  parenthesisEnd: {
    icon: IconParenthesisEnd,
    viewBox: "0 -1 2 13",
  },
};
</script>
